// extracted by mini-css-extract-plugin
module.exports = {"core-benefits":"style_core-benefits__tEF1o","boxmain":"style_boxmain__obbem","box":"style_box__uLOXy","industries-content":"style_industries-content__5oIth"};